import request from '@/utils/request';

export interface ESUser {
  id?: string;
  avatar?: string;
  roles?: number[];
  realName?: string;
}

export const login = (username: string, password: string) =>
  request({
    url: '/user/login',
    method: 'post',
    data: {
      username,
      password,
    },
  });

export const getUserInfo = (token: string) =>
  request({
    url: '/user/info',
    method: 'get',
  });

export const logout = () =>
  request({
    url: '/user/logout',
    method: 'post',
  });
